import { GlobalStateContext, ParamContext } from '../App'
import { useContext, useEffect, useState } from 'react'
import { isDT } from './Global'
import { ArMobileLinkModal } from './_commonComponents'
import ErrorBoundary from './ErrorBoundary'
import BannerTop from './BlockBanner'
import { arUrl } from './_makeUrls'
import ArButton from './ArButton'
import ClickableIcons from './ClickableIcons'

export default function BlockModelPresentation({ children, omitBanner, omitAR, dimensionsClicked }) {
	const { globalState } = useContext(GlobalStateContext)
	const { currentParams } = useContext(ParamContext)
	const [qrModalIsOpen, setQrModalIsOpen] = useState(false)
	const [qrUrl, setQrUrl] = useState(false)

	useEffect(() => {
		setQrUrl(arUrl(globalState.productId, currentParams))
	}, [globalState, currentParams])

	return (
		<ErrorBoundary>
			<div className="full-screen-container">
				<div className="main-page-container">
					{!omitBanner && <BannerTop alwaysFullWidth={true} />}
					<div className='content-div'>
						<ClickableIcons dimensionsClicked={dimensionsClicked} mobile={!isDT} />
						{!omitAR && <ArButton setQrModalIsOpen={setQrModalIsOpen} />}
						{children}</div>

				</div>
				<ArMobileLinkModal
					isOpen={qrModalIsOpen}
					setIsOpen={setQrModalIsOpen}
					qrUrl={qrUrl}
					language={globalState.language}
				/>
			</div>
		</ErrorBoundary>
	)
}
